window.addEventListener('DOMContentLoaded', () => {
  const tabsWrapper = document.querySelector('.product-mobile-tabs');
  const tabsElements = tabsWrapper.querySelectorAll('.accordion__content');
  let highestHeight = 0;

  tabsElements.forEach((tab) => {
    let nodeHeight = tab.getBoundingClientRect().height;
    if (nodeHeight > highestHeight) {
      highestHeight = Math.round(nodeHeight);
    }
  });
  tabsWrapper.setAttribute('style', `--blockHeight: ${highestHeight}px`);
});
